import { useState } from 'react';
import Modal from '@components/modal/Modal';
import useFetchMfaSetup from './hooks/useFetchMfaSetup';
import usePostMfaVerification from './hooks/usePostMfaVerification';
import MfaInner from '@components/mfa/MfaInner';

const MfaSetupModal: React.FC<MfaSetupModalProps> = ({ closeModal }) => {
    const [stage, setStage] = useState<'setup' | 'verify'>('setup');
    const { isFetching, fetchError, mfaSetupKey } = useFetchMfaSetup();
    const { isPosting, postError, formState, handleChange, handleSubmit } = usePostMfaVerification(
        false,
        closeModal,
    );

    return (
        <Modal title={stage === 'setup' ? 'Set up MFA' : 'Verify MFA'} closeModal={closeModal}>
            <MfaInner
                stage={stage}
                setStage={setStage}
                isFetching={isFetching}
                fetchError={fetchError}
                mfaSetupKey={mfaSetupKey}
                handleSubmit={handleSubmit}
                isPosting={isPosting}
                postError={postError}
                formState={formState}
                handleChange={handleChange}
                cancelAction={closeModal}
            />
        </Modal>
    );
};

interface MfaSetupModalProps {
    closeModal: () => void;
}

export default MfaSetupModal;
